import React from 'react';

const ArticleCard = ({ article, quantity, onQuantityChange }) => {
  const handleIncrease = () => {
    onQuantityChange(article.id, 1);
  };

  const handleDecrease = () => {
    onQuantityChange(article.id, -1);
  };

  return (
    <div className="article-card">
      <button
        type="button"
        className="card-tap-zone card-tap-zone-top"
        onClick={handleIncrease}
        aria-label={`Aumentar cantidad de ${article.name}`}
      />
      <button
        type="button"
        className="card-tap-zone card-tap-zone-bottom"
        onClick={handleDecrease}
        aria-label={`Disminuir cantidad de ${article.name}`}
      />

      <div className="article-content">
        <div className="article-info">
          <h3 className="article-name">{article.name}</h3>
          <span className="article-category">{article.category}</span>
          <span className="article-price">${article.price.toFixed(2)}</span>
        </div>

        <div className="quantity-display" aria-live="polite">
          {quantity}
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;
